"use client";

import { InfoGroup } from "#/components/InfoGroup/InfoGroup";

import { usePerpPortfolioImpactController } from "./PerpPortfolioImpact.controller";

export const PortfolioImpact: React.FC = () => {
  const { isValid, marginData, isLoading, isMissingDetails } =
    usePerpPortfolioImpactController();

  if (isMissingDetails || !isValid) return null;

  return (
    <InfoGroup
      variant="normal"
      rows={marginData}
      isLoading={isLoading}
      className="mt-2 w-full"
      title="Portfolio Impact"
    />
  );
};
